// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Box } from '@mantine/core';
import { useMantineTheme, useMantineColorScheme } from '@mantine/core';
import { Stack, Group, Center, Container } from '@/components/ui/layout';
import { Title, Text, Button, Anchor, Badge } from '@/components/ui/core';
import { TextInput, PasswordInput, Checkbox } from '@/components/ui/inputs';
import { IconMail, IconLock, IconArrowLeft, Icon3dCubeSphere } from '@tabler/icons-react';
import { FadeIn } from '@/components/animations';
import { Floating3DCard, SocialLoginButtons } from '../components';

export default function LoginMinimal3D() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const theme = useMantineTheme();
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === 'dark';

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Login attempt:', { email, password, rememberMe });
  };

  return (
    <Box
      style={{
        minHeight: '100vh',
        background: isDark
          ? `linear-gradient(180deg, ${theme.colors.dark[8]} 0%, ${theme.colors.dark[9]} 100%)`
          : `linear-gradient(180deg, ${theme.colors.gray[0]} 0%, ${theme.colors.gray[1]} 100%)`,
        position: 'relative',
      }}
    >
      {/* Subtle pattern */}
      <Box
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `radial-gradient(${isDark ? theme.colors.dark[6] : theme.colors.gray[3]} 1px, transparent 1px)`,
          backgroundSize: '32px 32px',
          opacity: 0.5,
          pointerEvents: 'none',
        }}
      />

      <Center mih="100vh" p="xl" style={{ position: 'relative', zIndex: 1 }}>
        <Container size="xs" w="100%">
          <FadeIn delay={100}>
            <Floating3DCard
              maxTilt={8}
              floatingShadow
              glow
              glowColor={theme.colors.indigo[5]}
              radius="lg"
            >
              <Stack gap="lg">
                {/* Back button */}
                <Button
                  component={Link}
                  to="/app/demo/auth-pages/login"
                  variant="subtle"
                  size="xs"
                  leftSection={<IconArrowLeft size={14} />}
                  w="fit-content"
                >
                  Back to variants
                </Button>

                {/* Header */}
                <Stack align="center" gap="xs">
                  <Badge
                    leftSection={<Icon3dCubeSphere size={12} />}
                    variant="gradient"
                    gradient={{ from: 'gray', to: 'dark' }}
                    size="lg"
                  >
                    Minimal 3D
                  </Badge>
                  <Title order={2} ta="center" mt="md">
                    Welcome
                  </Title>
                  <Text c="dimmed" size="sm" ta="center">
                    Interactive 3D card experience
                  </Text>
                </Stack>

                {/* Form */}
                <form onSubmit={handleSubmit}>
                  <Stack gap="md">
                    <TextInput
                      label="Email"
                      placeholder="your@email.com"
                      leftSection={<IconMail size={16} />}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      size="md"
                      radius="md"
                      variant="filled"
                    />

                    <PasswordInput
                      label="Password"
                      placeholder="Your password"
                      leftSection={<IconLock size={16} />}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      size="md"
                      radius="md"
                      variant="filled"
                    />

                    <Group justify="space-between">
                      <Checkbox
                        label="Stay signed in"
                        checked={rememberMe}
                        onChange={(e) => setRememberMe(e.currentTarget.checked)}
                      />
                      <Anchor
                        component={Link}
                        to="/app/demo/auth-pages/forgot-password/minimal3d"
                        size="sm"
                      >
                        Forgot password?
                      </Anchor>
                    </Group>

                    <Button
                      type="submit"
                      fullWidth
                      size="md"
                      radius="md"
                      color="dark"
                    >
                      Continue
                    </Button>
                  </Stack>
                </form>

                {/* Social Login */}
                <SocialLoginButtons
                  providers={['google', 'github', 'apple']}
                  layout="icons-only"
                  dividerLabel="or"
                />

                {/* Register Link */}
                <Text ta="center" size="sm">
                  New here?{' '}
                  <Anchor component={Link} to="/app/demo/auth-pages/register/minimal3d" fw={500}>
                    Create account
                  </Anchor>
                </Text>
              </Stack>
            </Floating3DCard>
          </FadeIn>
        </Container>
      </Center>
    </Box>
  );
}
